import {useReactToPrint} from 'react-to-print';
import styles from './useStandardPrint.module.scss';
import {MutableRefObject} from 'react';

const useStandardPrint = (ref: MutableRefObject<any>) => useReactToPrint({
  content: () => ref.current,
  // Ensure clean page margins and valid CSS (removed stray brace)
  pageStyle: '@page { size: auto; margin: 4rem 2rem; }',
  bodyClass: styles['print']
});

export default useStandardPrint;
